export default __webpack_public_path__ + "static/stanleyknifecrumble-13f189074476ba29761dc0c192dc6f4b.png";